import './orionx-logo'
import React from 'react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles'
import { init as initApm } from '@elastic/apm-rum'
import getEnv from 'App/Root/getEnv'

const init = async () => {
  const apm = initApm({
    // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
    serviceName: 'frontend',

    // Set custom APM Server URL (default: http://localhost:8200)
    serverUrl: 'https://apm-server.galaxy.orionx.com',

    // Set service version (required for sourcemap feature)
    serviceVersion: '1.0.0',
  })

  window.apm = apm
  const userId = localStorage.getItem('Meteor.userId')
  if (userId) apm.setUserContext({ id: userId })
}

init()

const root = createRoot(document.getElementById('root'))

if (getEnv() === 'prod') {
  root.render(<App />)
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
